<div class="flex--row comment">
  <mat-form-field class="flex__child comment__input">
    <textarea matInput [formControl]="comment" [placeholder]="'comments' | translate"></textarea>
  </mat-form-field>
  <div class="flex__child--none comment__button">
    @if (!postDisabled) {
      <button color="warn" mat-icon-button type="button" (click)="save()">
        <mat-icon>save</mat-icon>
      </button>
    }
    <div class="comment__spinner">
      @if (postDisabled) {
        <mat-spinner [diameter]="20"></mat-spinner>
      }
    </div>
  </div>
</div>
